import { render, staticRenderFns } from "./ContentSetting.vue?vue&type=template&id=378f751e&"
import script from "./ContentSetting.vue?vue&type=script&lang=js&"
export * from "./ContentSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports